import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, message } from 'antd';
import { Colors } from '../../helpers/Colors';
import DynamicTable from '../TableComponents/DynamicTable';
import { PlusOutlined } from '@ant-design/icons';
import { AddLocomotiveNotes, getAllNotes } from '../../Services/LocomotiveServices';
import moment from 'moment';
import roleManager from '../roles';
const NotesModal = ({ open, close, data }) => {
    const [newNote, setNewNote] = useState(false)
    const [TableData, setTableData] = useState([])
    const [updateInProgress, setUpdateInProgress] = useState(false);

    const { TextArea } = Input;
    const [form] = Form.useForm()
    let table = {
        header: [
            "ID",
            "Date/Time",
            "Enter By",
            "Note"
        ],
        rows: TableData?.map(row => [
            row?.id,
            moment.utc(row?.createdAt).format('MM-DD-YYYY HH:mm:ss') || "N-A",
            <p>
                {row?.Employee?.firstName + " " + row?.Employee?.lastName}
            </p>,
            <p style={{ width: "300px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: 'pre-wrap' }}>
                {row?.EquipNote}
            </p>
        ])
    }
    const getNotes = async () => {
        const result = await getAllNotes(data?.id)
        if (result.httpStatus === 200) {
            setTableData(result.data)
        }
    }
    const HandleSubmit = async (values) => {
        if (updateInProgress) {
            return; // Do nothing if an update is already in progress
        }
    
        setUpdateInProgress(true); // Set the update in progress
    
        let dataobj = {
            EquipNote: values?.Notes
        };
    
        try {
            const result = await AddLocomotiveNotes(data?.id, dataobj);
    
            if (result?.httpStatus === 200) {
                message.success('Note created successfully!');
                form.setFieldsValue({ Notes: "" });
                getNotes();
                setNewNote(false);
                 
            }
        } catch (error) {
            console.error('Error while updating note:', error);
        } finally {
            setUpdateInProgress(false); // Reset the update status, whether successful or not
        }
    };
    
    // const HandleSubmit = async (values) => {
    //     if (updateInProgress) {
    //         return; // Do nothing if an update is already in progress
    //     }
    //     setUpdateInProgress(true); // Set the update in progress

    //     let dataobj = {
    //         EquipNote: values?.Notes
    //     }
    //     const result = await AddLocomotiveNotes(data?.id, dataobj)
    //     if (result?.httpStatus === 200) {
    //         message.success('Note created successfully!');
    //         form.setFieldsValue({ Notes: "" })
    //         getNotes()
    //         setNewNote(false)
    //          

    //     }
        
    // }
    const validateSpace = (rule, value, callback) => {
        if (value && value.trim() === '') {
            callback('Notes cannot be empty');
        } else {
            callback();
        }
    };
    useEffect(() => {
        setNewNote(false)
        if (open) {
            getNotes()
        }
        form.setFieldsValue({ EquipID: data?.EquipUID })

    }, [open])
    return (
        <>
            <Modal width={newNote ? 500 : 900} title={
            <div>
                <p style={{ color: Colors.mainBlue, fontWeight: "600", marginBottom: "0px ", fontSize: "24px" }}>Notes </p>
                <div style={{ display: "flex", gap: "10px" }}>
                    {/* <p style={{ , marginBottom: "0px" }}>Equipment ID:</p> */}
                </div>
            </div>} open={open} onCancel={() => { close('Notes') }} footer={null}>
                {/* Table----------> */}
               
               { }
                {
                    !newNote && roleManager("locomotive", "lookupEdit", "addNotes") &&  data?.status?.status !== "DEL" &&
                    <div style={{ marginBottom: "10px", display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
                        <p style={{ color: "black", fontWeight: "800", marginBottom: "0px", fontSize: "20px", marginTop: "-30px" }}>{data?.EquipUID}</p>


                        <Button onClick={() => { setNewNote(true) }} style={{ background: Colors.mainBlue, color: "white" }}><PlusOutlined /> Add Note</Button>
                    </div>
                }
                <div style={{}}>
                    {
                        newNote ?
                            <Form form={form} name='equipID' onFinish={HandleSubmit} style={{ width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                                        <p style={{ color: 'black', fontWeight: "700", fontSize: '15px', whiteSpace: "nowrap" }}>Equip ID</p>
                                        <Form.Item style={{ width: "100%", display: 'flex', justifyContent: "flex-end" }} name={'EquipID'} rules={[{ required: true, message: "Equip Id is required" }]}>
                                            <Input type={'Text'} placeholder='N-A' readOnly={true} style={{
                                                background: 'none',
                                                border: `1px solid lightgray`,
                                                fontSize: "13px",
                                                width: "300px"
                                            }} />
                                        </Form.Item>

                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                                        <p style={{ color: 'black', fontWeight: "700", fontSize: '15px' }}>Notes</p>
                                        <Form.Item style={{ width: "100%", display: 'flex', justifyContent: "flex-end" }} name={'Notes'} rules={[{ required: true, message: "Notes are required" }, { validator: validateSpace, message: "Notes are required" }]}>
                                            <TextArea rows={4} type={'Text'} placeholder='Enter Notes.' style={{
                                                background: 'none',
                                                border: `1px solid lightgray`,
                                                fontSize: "13px",
                                                width: '300px',
                                                textAlign: "start"
                                            }}
                                                maxLength={200}
                                            />
                                        </Form.Item>

                                    </div>
                                </div>
                                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                                    <Button htmlType='submit' style={{ background: Colors.mainBlue, color: "white" }}>
                                        Update
                                    </Button>
                                    <Button onClick={() => { setNewNote(false) }} style={{ background: 'white', color: Colors.mainBlue }}>
                                        Notes List
                                    </Button>
                                </div>
                            </Form>
                            :
                            <DynamicTable tableData={table} />
                    }
                </div>
            </Modal>
        </>
    );
};
export default NotesModal;